// What the server last told us about itself: the build it runs and that
// build's one-line note. Fed by the version check the app already makes on
// start and on every return to the foreground, so anything that shows "what
// changed" reads from here instead of racing its own fetch against sign-in.
import { create } from 'zustand'

interface ServerState {
  version?: string
  note?: string
  set(info: { version?: string; note?: string }): void
}

export const useServer = create<ServerState>((set) => ({
  set: (info) => set({ version: info.version, note: info.note }),
}))
